import { render } from "./OrderSummaryAndConfirmation.vue?vue&type=template&id=505a5ae4&scoped=true&ts=true"
import script from "./OrderSummaryAndConfirmation.vue?vue&type=script&lang=ts"
export * from "./OrderSummaryAndConfirmation.vue?vue&type=script&lang=ts"

import "./OrderSummaryAndConfirmation.vue?vue&type=style&index=0&id=505a5ae4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_typescript@5.9.3__webpack@5.109.2_postcss@8.5.26_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505a5ae4"]])

export default __exports__